module.exports = __webpack_public_path__ + "img/signout.6299af15.svg";